import {
  InvoiceSplitCardAmount,
  InvoiceSplitCardAmountGroup,
  InvoiceSplitCardBreakdown,
  InvoiceSplitCardDescription,
  InvoiceSplitCardHeader,
  InvoiceSplitCardHighlight,
  InvoiceSplitCardOverview,
  InvoiceSplitCardRoot,
  InvoiceSplitCardRow,
  InvoiceSplitCardRows,
  InvoiceSplitCardTitle,
} from './InvoiceSplitCard.parts';

export const InvoiceSplitCard = {
  Root: InvoiceSplitCardRoot,
  Overview: InvoiceSplitCardOverview,
  Header: InvoiceSplitCardHeader,
  Title: InvoiceSplitCardTitle,
  Description: InvoiceSplitCardDescription,
  Highlight: InvoiceSplitCardHighlight,
  Rows: InvoiceSplitCardRows,
  Row: InvoiceSplitCardRow,
  Breakdown: InvoiceSplitCardBreakdown,
  AmountGroup: InvoiceSplitCardAmountGroup,
  Amount: InvoiceSplitCardAmount,
};
